import { render, staticRenderFns } from "./QPromotionTrackerChart.vue?vue&type=template&id=18f968cc&scoped=true&"
import script from "./QPromotionTrackerChart.vue?vue&type=script&lang=js&"
export * from "./QPromotionTrackerChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f968cc",
  null
  
)

export default component.exports